import { COLORS } from 'helpers/globals'

const clip = {
  position: 'absolute',
  background: '#eeeeee',
  width: '100%'
}

const topClip = {
  ...clip,
  top: 0,
  left: 0
}

const bottomClip = {
  ...clip,
  bottom: 0,
  right: 0
}

export default {
  container: {
    width: '100%',
    height: 'calc(100vw * 3 / 4)'
  },
  image: {
    position: 'relative',
    backgroundRepeat: 'no-repeat',
    height: '100%',
    width: '100%',
    touchAction: 'none'
  },
  topClip,
  bottomClip,
  rightClip: {
    ...topClip,
    height: '100%'
  },
  leftClip: {
    ...bottomClip,
    height: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/SimulatedView/ViewImage/style.js